import { createTheme } from "@mui/material";

const theme = createTheme({
  breakpoints: {
    values: {
      mobile: 610,
    },
  },
  palette: {
    primary: {
      main: "#36BBA0",
      dark: "#129479",
      light: "#C6F6D5",
    },
    secondary: {
      main: "#129479",
    },
    neutral: {
      main: "#FFFFFF",
    },
    error: {
      main: "#FF0000",
    },
    dark: {
      main: "#000000",
    },
  },
  bg: {
    main: "#fff",
    light: "#F4F5F7",
  },
  text: {
    primary: "#000000",
    secondary: "#718096",
    light: "#FFF",
  },
});

export default theme;
